export const CONSENT_KEY = "cookie_consent_v1";

export const hasConsent = (): boolean => {
    try {
        return localStorage.getItem(CONSENT_KEY) === "true";
    } catch {
        return false;
    }
};
